import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px = 'M13 5.61 8 11 3 5.58Z';
const draw24px = 'M17,9.72l-5,5.42-5-5.42Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TriangleDownIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'triangleDown'),
) as IconWithRender;

TriangleDownIcon.displayName = 'TriangleDownIcon';
TriangleDownIcon.propTypes = Icon.propTypes;
TriangleDownIcon.renderIcon = (props) => <TriangleDownIcon {...props} />;
export default TriangleDownIcon;
